import React from 'react';
import { ReactComponent as Logo } from 'assets/img/vectors/logo/Upward_Logo.svg';

const UpwardLogo = ({ height, fill }) => (
   <Logo {...(height ? { height: height } : {})} {...(fill ? { fill: fill } : {})} />
);

export default UpwardLogo;
